import React from "react";
import { Link } from "react-router-dom";

type Contactprops = {
  name: string;
  location: string;
  email: string;
  linkedinUrl: string;
  locationUrl: string;
  emailUrl: string;
  locationIcon?: React.ReactNode;
  emailIcon?: React.ReactNode;
};

const ContactDetails = ({
  name,
  location,
  email,
  locationUrl,
  linkedinUrl,
  emailUrl,
}: // locationIcon,
// emailIcon,
Contactprops) => {
  return (
    <div className=" flex flex-col gap-x-4">
      {/* Name */}
      <div className="ml-1 blade-top-margin sm:mt-0 flex gap-2 sm:ml-0 ">
        <svg
          className="lg:mt-2 2xl:mt-3 sm:mt-2"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5629 20.8965H4.4381C3.73211 20.8965 3.21012 20.1995 3.47711 19.5585C4.71309 16.5945 7.61704 14.8965 11 14.8965C14.3839 14.8965 17.2879 16.5945 18.5239 19.5585C18.7908 20.1995 18.2689 20.8965 17.5629 20.8965ZM6.91705 8.89647C6.91705 6.69047 8.74902 4.89647 11 4.89647C13.2519 4.89647 15.0829 6.69047 15.0829 8.89647C15.0829 11.1025 13.2519 12.8965 11 12.8965C8.74902 12.8965 6.91705 11.1025 6.91705 8.89647ZM20.9558 20.5325C20.2138 17.1735 17.8919 14.6945 14.8369 13.5695C16.4559 12.2924 17.3999 10.2274 17.0529 7.96642C16.6509 5.34342 14.4229 3.24446 11.735 2.93846C8.02304 2.51546 4.87509 5.34547 4.87509 8.89647C4.87509 10.7865 5.76908 12.4704 7.16405 13.5695C4.10711 14.6945 1.78714 17.1735 1.04416 20.5325C0.774161 21.7535 1.77915 22.8965 3.05412 22.8965H18.9458C20.2218 22.8965 21.2258 21.7535 20.9558 20.5325Z"
            fill="#8DC73F"
          />
        </svg>
        <h5 className="ml-1 w-full font-lato-regular sm:ml-0 sm:mt-2 xl:max-w-[70%] 2xl:max-w-[55%]">
          <a
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {name}
          </a>
        </h5>
      </div>

      {/* Location */}
      <div className="ml-[2px] mt-2 sm:mt-0 flex gap-x-2 sm:ml-0">
        <svg
          className="sm:mt-3"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Location" clipPath="url(#clip0_948_1359)">
            <path
              id="Vector"
              d="M12.8618 0.213379C10.1561 0.213379 7.56131 1.28819 5.64813 3.20136C3.73496 5.11453 2.66016 7.70934 2.66016 10.415C2.66016 17.3011 11.6503 25.0798 12.0329 25.4113C12.2639 25.6089 12.5578 25.7175 12.8618 25.7175C13.1657 25.7175 13.4597 25.6089 13.6906 25.4113C14.137 25.0798 23.0634 17.3011 23.0634 10.415C23.0634 7.70934 21.9885 5.11453 20.0754 3.20136C18.1622 1.28819 15.5674 0.213379 12.8618 0.213379ZM12.8618 22.7206C10.1456 20.1703 5.21056 14.6741 5.21056 10.415C5.21056 8.38575 6.01666 6.43964 7.45154 5.00476C8.88642 3.56988 10.8325 2.76378 12.8618 2.76378C14.891 2.76378 16.8371 3.56988 18.272 5.00476C19.7068 6.43964 20.513 8.38575 20.513 10.415C20.513 14.6741 15.5779 20.183 12.8618 22.7206ZM12.8618 5.31418C11.8529 5.31418 10.8667 5.61333 10.0279 6.17382C9.18908 6.7343 8.5353 7.53093 8.14923 8.46298C7.76316 9.39503 7.66215 10.4206 7.85896 11.4101C8.05578 12.3995 8.54158 13.3084 9.25494 14.0218C9.9683 14.7351 10.8772 15.2209 11.8666 15.4178C12.8561 15.6146 13.8817 15.5136 14.8137 15.1275C15.7458 14.7414 16.5424 14.0876 17.1029 13.2488C17.6634 12.41 17.9626 11.4238 17.9626 10.415C17.9626 9.06216 17.4251 7.76475 16.4686 6.80817C15.512 5.85158 14.2146 5.31418 12.8618 5.31418ZM12.8618 12.9654C12.3573 12.9654 11.8642 12.8158 11.4448 12.5356C11.0254 12.2553 10.6985 11.857 10.5055 11.391C10.3125 10.9249 10.262 10.4121 10.3604 9.91742C10.4588 9.42269 10.7017 8.96825 11.0583 8.61157C11.415 8.25489 11.8695 8.01199 12.3642 7.91358C12.8589 7.81517 13.3717 7.86568 13.8377 8.05871C14.3038 8.25175 14.7021 8.57864 14.9823 8.99805C15.2626 9.41746 15.4122 9.91055 15.4122 10.415C15.4122 11.0914 15.1434 11.7401 14.6652 12.2184C14.1869 12.6967 13.5382 12.9654 12.8618 12.9654Z"
              fill="#8DC73F"
            />
          </g>
          <defs>
            <clipPath id="clip0_948_1359">
              <rect
                width="25.725"
                height="25.725"
                fill="white"
                transform="translate(0 0.103027)"
              />
            </clipPath>
          </defs>
        </svg>
        <h5 className="ml-1 w-full font-lato-regular sm:ml-0 sm:mt-2 xl:max-w-[70%] 2xl:max-w-[55%]">
          <a
            href={locationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className=" hover:underline"
          >
            {location}
          </a>
        </h5>
      </div>

      {/* Email */}
      <div className="ml-1 mt-2 sm:mt-0 flex gap-x-2 sm:ml-0">
        <svg
          className="sm:mt-3"
          width="26"
          height="27"
          viewBox="0 0 26 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Mail">
            <g id="XMLID_146_">
              <path
                id="XMLID_426_"
                d="M21.6994 4.52872L12.4151 4.55158L3.13077 4.50586H3.12624C1.87808 4.50586 0.887695 5.69014 0.887695 7.17164V19.5815C0.887695 21.063 1.87808 22.2473 3.12624 22.2473H21.713C22.9611 22.2473 23.9515 21.063 23.9515 19.5815V7.17164C23.9515 5.69014 22.9702 4.52872 21.6994 4.52872ZM20.9713 6.35773L12.6774 14.0259L12.6457 14.0533L12.6186 14.0853C12.5191 14.195 12.4015 14.2088 12.3382 14.2088C12.2749 14.2088 12.1573 14.1905 12.0623 14.0762L12.0352 14.0442L4.10759 6.32115L12.4151 6.37602L20.9713 6.35773ZM21.713 20.4183H3.12624C2.96796 20.4183 2.69662 20.1165 2.69662 19.5815V7.46428L10.7283 15.3107C11.1353 15.768 11.7096 16.0332 12.3201 16.0423H12.3473C12.9487 16.0423 13.5095 15.7909 13.921 15.3519L22.1516 7.73406V19.5815C22.1426 20.1165 21.8713 20.4183 21.713 20.4183Z"
                fill="#8DC73F"
              />
            </g>
          </g>
        </svg>
        <h5 className="ml-1 w-full font-lato-regular sm:ml-0 sm:mt-2 xl:max-w-[70%] 2xl:max-w-[55%] hover:underline">
          <a href={`mailto:${email}`}>{email}</a>
        </h5>
      </div>
    </div>
  );
};

export default ContactDetails;
